module.exports = __webpack_public_path__ + "static/media/shreya_singhal.afcf35fe.jpg";